
define('known/models/leagueUserModel',[
	'jquery',
	'underscore',
	'backbone',
	
	//Shims
	'backbone.relational'
], function($, _, Backbone){
	var LeagueUser = Backbone.RelationalModel.extend({
		defaults: {
			id: null,
			//leagueInstanceId: null,
			leagueUserRole: null,
			userName: null,
			displayName: null,
			timeSinceActivity: 0, //duration in milli since they checked in online
			activityTime: 0
	    },
	    
	    //urlRoot: function() {
		//	return '/draftapp/leagues/' + this.get("leagueId") + '/league-instances/' + this.get("leagueInstanceId").get('id') + '/league-users/';
		//},
		
		urlRoot: function() {
	    	var lgId = this.lgId ? this.lgId : this.get("leagueInstanceId").get("leagueId");
	    	var lgInstId = this.lgInstId ? this.lgInstId : this.get("leagueInstanceId").get("id");
	    	
	    	return '/draftapp/leagues/' 
	    			+ lgId 
	    			+ '/league-instances/' 
	    			+ lgInstId 
	    			+ '/league-users/';
		},

		initialize: function(models, options) {
			if(options.lgInstId && options.lgId){
				this.lgInstId = options.lgInstId;
				this.lgId = options.lgId;
			}
	    },
	    
	    prettyDispName: function() {
	    	var dispName = this.get("userName").toLowerCase();
			if(this.get("displayName")){
				dispName = this.get("displayName");
			}
			
			return dispName;
	    }
	});
	
	return LeagueUser;  
});
